module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jLOnq"))).then(() => parcelRequire('ikE14'));